var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionSymbol = function SvgQuestionSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 37 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.232.31C8.654.31 3.416 5.624 1.568 7.974.54 9.303-.282 11.755.13 14.106c.308 1.635 1.335 4.088 4.724 3.985 3.39-.102 3.8-2.35 5.649-4.19 1.746-1.737 5.34-3.168 8.524-3.168 1.849 0 6.06.41 6.06 3.27 0 1.329-2.465 3.27-3.903 4.088-2.362 1.329-7.19 4.803-7.19 9.504l.206 4.292c0 3.27 2.054 5.621 5.032 5.621 2.979 0 4.828-2.044 4.828-5.62 0-3.577 2.875-5.11 2.875-5.11 3.287-1.84 9.757-5.008 9.757-11.855 0-7.255-6.06-14.613-17.46-14.613ZM19.54 53.348c3.12 0 5.65-2.516 5.65-5.62 0-3.105-2.53-5.621-5.65-5.621-3.12 0-5.648 2.516-5.648 5.62 0 3.105 2.529 5.621 5.649 5.621Z",
    fill: "currentColor"
  })));
};
export { SvgQuestionSymbol as ReactComponent };
export default __webpack_public_path__ + "d7a4006808c681f44893ef2ff82cc1df.svg";